// Class-name composer for dashboard primitives: clsx for conditionals, then
// tailwind-merge so a caller's className wins over a recipe class on conflict.
//
// tailwind-merge only knows Tailwind's default scale names. ui/theme.css adds
// semantic font sizes, one shadow and app containers; unregistered, the merger
// reads `text-lead text-fg-1` as two text COLOURS and silently drops
// `text-lead` (same for `shadow-overlay`, `max-w-app*`). Register them here —
// keep this list in sync with the @theme block in ui/theme.css.

import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["display", "title", "heading", "lead", "price"],
      shadow: ["overlay"],
      container: ["page", "reading", "app", "app-narrow"],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
